import { Link } from "./link.model"

export const EmailTypes = {
	CONFIRMATION: "Kaufbestätigung",
	DELIVERY: "Lieferung",
	COMPLETION: "Versandbestätigung"
}

export class MerchantEmailConfig {
	uuid: string;
	emailType: string;
	subject: string;
	sender: string;
	template: string;
	_links: {
		self: Link;
		merchant: Link;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/merchant-email-config.model.ts